import axios from 'axios'

export default {
  activeDocId: '',
  activeFolder: ['', ''],
  activeModal: '',
  activeReviewState: 'Unprocessed',
  activeCheckAll: false,
  autoSaveState: '',
  checkedDocIds: [],
  currentMarkupUpdatedAt: '',
  // Maps IDs to documents.
  documents: {},
  folders: [],
  folderOptions: [],
  getDocumentReviewListCancelToken: axios.CancelToken.source(),
  infiniteId: +new Date(),
  infinitePage: 1,
  prettyId: '',
  processingDocIds: [],
  regexes: [],
  reviewStateCounts: {
    'Needs redaction': 0,
    Processed: 0,
    Ready: 0,
    Redacted: 0,
    Unprocessed: 0,
    'Non-responsive': 0
  },
  rules: [],
  searchTerm: '',
  searchProcesses: {},
  testStrings: [{ name: 'this is a test' }, { name: 'second' }],
  viewingSessionId: '',
  totalDocCount: '',
  i18n: '',
  redactionReasons: {}
}
